
import { Component, Prop, Vue } from 'nuxt-property-decorator'
import AppAccordion from '~/components/AppAccordion/AppAccordion.vue'
import AppAccordionItem from '~/components/AppAccordion/AppAccordionItem.vue'
import ContentCard from '~/components/ContentCard/ContentCard.vue'
import ContentCardText from '~/components/ContentCard/ContentCardText.vue'
import { FAQItem } from '~/composables/seo.composable'

@Component({
  components: {
    AppAccordion,
    AppAccordionItem,
    ContentCard,
    ContentCardText,
  },
})
export default class OfferPageFaq extends Vue {
  @Prop({
    type: Array,
    required: true,
  })
  items!: FAQItem[]
}
